'use client';

import {
  CheckIcon,
  ShareIcon
} from '@heroicons/react/24/outline';
import { useState } from 'react';
import { BlogPost } from '../../../data/blogPosts';

interface ShareButtonProps {
  blogPost: BlogPost;
}

export default function ShareButton({ blogPost }: ShareButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleShare = async () => {
    if (!blogPost) return;
    
    const url = window.location.href;
    const title = blogPost.title;
    const text = blogPost.excerpt;

    try {
      // Try to use the Web Share API first (works on mobile and some desktop browsers)
      if (navigator.share) {
        await navigator.share({
          title,
          text,
          url
        });
      } else {
        // Fallback: copy URL to clipboard
        await navigator.clipboard.writeText(url);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      }
    } catch {
      // If Web Share API fails, fallback to clipboard
      try {
        await navigator.clipboard.writeText(url);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } catch (clipboardError) {
        console.error('Failed to copy to clipboard:', clipboardError);
        // Last resort: show URL in alert
        alert(`Share this URL: ${url}`);
      }
    }
  };

  return (
    <button 
      onClick={handleShare}
      className="inline-flex items-center text-gray-500 hover:text-gray-700 transition-colors"
    >
      {isCopied ? (
        <>
          <CheckIcon className="h-5 w-5 mr-2 text-green-600" />
          <span className="text-green-600">Copied!</span>
        </>
      ) : (
        <>
          <ShareIcon className="h-5 w-5 mr-2" />
          Share
        </>
      )}
    </button>
  );
} 